import React from "react";
import { cn } from "../../../../../../utils/classnames";

const VehicleCell = ({ vehicleType = "-", bold }) => (
  <div className="tw:flex tw:w-full tw:items-center">
    <div
      className={cn(
        "tw:font-hanken-grotesk tw:text-[#282828] tw:text-[15px] tw:leading-[22px]",
        bold ? "tw:font-bold" : "tw:font-normal"
      )}
    >
      {vehicleType}
    </div>
  </div>
);

export default VehicleCell;
